import {
    NavigationContext,
    SuperbetRouteConfig,
} from '@superbet-group/web.types';

import { Link } from '@app/router/constants/Link';
import { RouteName } from '@app/router/constants/RouteName';
import { Title } from '@app/router/constants/Title';
import { defaultLayout } from '@app/router/utils';
import LandingPage from '@pages/LandingPage/index.vue';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import { omit as _omit } from 'lodash';
import { getShellConfig } from '@src/config/shell/config';

const areSitesSplitByLicence = getShellConfig().remoteConfig.areSitesSplitByLicence;

export const marketingLandingRoutes: SuperbetRouteConfig[] = [
    {
        path: Link.GrowthMarketing.LandingIntro,
        name: RouteName.GrowthMarketing.LandingIntro,
        components: {
            ...(shellLocalConfig.hasTicketsOutsideSportsProduct
                ? defaultLayout
                : _omit(defaultLayout, ['tickets'])
            ),
            content: LandingPage,
        },
        meta: {
            title: Title.GrowthMarketing.LandingIntro,
            layoutClass: `landing ${areSitesSplitByLicence ? 'landing-full-width' : ''}`,
            navigationContext: NavigationContext.Neutral,
            mobileHeaderConfig: {
                isTopLevelRoute: true,
                isHome: true,
            },
        },
    },
];
